<template lang="pug">
.biz-intro.flex-mid
  .title 学生中心入口
  .subtitle 快去APP学生中心领取查看更多权益
  .operation
    .operation-item.flex-mid
      img.pic(
        src="https://m.hellobike.com/resource/AppPlatformH5/base-success/odOlTAkQ1js6nl0JC0uXR.png"
      )
      .hint 打开哈啰APP，点击学生特权图标
      .num.flex-mid 1
    .operation-item.flex-mid
      img.pic(
        src="https://m.hellobike.com/resource/helloyun/07177/A3x3KXvmS6.png?x-oss-process=image/quality,q_80"
      )
      .hint 进入学生中心领取或查看学生专属权益
      .num.flex-mid 2
</template>

<script>
export default {};
</script>

<style lang="less" scoped>
.biz-intro {
  flex-direction: column;
  background: linear-gradient(180deg, #fff 0%, #fff 100%);
  border-radius: 0.08rem;
  padding: 0.24rem 0.28rem;

  .title {
    font-size: 0.16rem;
    font-weight: 500;
    color: #4b4b4b;
  }

  .subtitle {
    font-size: 0.12rem;
    color: rgba(116, 116, 146, 0.83);
  }

  .operation {
    display: flex;
    justify-content: space-between;
    margin-top: 0.26rem;
    width: 100%;

    .operation-item {
      display: flex;
      flex-direction: column;
      position: relative;

      .pic {
        width: 1.3rem;
        height: 2.65rem;
        margin-bottom: 0.1rem;
      }

      .num {
        position: absolute;
        width: 0.18rem;
        height: 0.18rem;
        background: linear-gradient(135deg, #7478ff 0%, #5459f7 100%);
        box-shadow: 0 0 0.04rem 0 rgba(98, 103, 250, 0.26);
        font-size: 0.14rem;
        font-weight: 500;
        left: -0.04rem;
        top: -0.01rem;
        border-radius: 50%;
        color: rgba(255, 255, 255, 0.83);
      }

      .hint {
        font-size: 0.12rem;
        color: #5a6066;
        max-width: 1.24rem;
      }
    }
  }
}
</style>
